import React from 'react'

import styles from './Pipe.module.css'

export default function Pipe() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.pipe} />
    </div>
  )
}
